interface Props {
  title: string;
  code: string;
  caption?: string;
}

export default function CodeSnippet({ title, code, caption }: Props) {
  return (
    <div>
      <div className="code-card">
        <div className="code-head">
          <span className="bk">[</span> {title} <span className="bk">]</span>
        </div>
        <pre className="code-body">{code}</pre>
      </div>
      {caption && <p className="code-cap">{caption}</p>}
    </div>
  );
}
